import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import { PlanosComponent } from "./planos.component";
import {PlanosRoutingModule} from "./planos-routing.module";
import {PlanoApiService} from "./shared/plano-api.service";
import {PlanoNavigationService} from "./shared/plano-navigation.service";
import {PlanoService} from "./shared/plano.service";
import {PlanoListComponent} from "./plano-list/plano-list.component";
import {PlanosFormComponent} from "./plano-form/plano-form.component";
import {ServicosModule} from "../servicos/servicos.module";

@NgModule({
  imports: [
    SharedModule,
    ServicosModule,
    PlanosRoutingModule
  ],
  providers: [
    PlanoApiService,
    PlanoNavigationService,
    PlanoService
  ],
  declarations: [
    PlanosComponent,
    PlanoListComponent,
    PlanosFormComponent
  ]
})
export class PlanosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/planos.module.ts
 **/